/* tslint:disable */
/* eslint-disable */
/**
 * DAM PORTAL API
 * API for handling DAM PORTAL operations.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Navigation Wrapper
 * @export
 * @interface Navigation
 */
export interface Navigation {
    /**
     * Node ID
     * @type {number}
     * @memberof Navigation
     */
    id: number;
    /**
     * Node Label
     * @type {string}
     * @memberof Navigation
     */
    label: string;
    /**
     * List of navigation children.
     * @type {Array<Navigation>}
     * @memberof Navigation
     */
    children?: Array<Navigation>;
}

export function NavigationFromJSON(json: any): Navigation {
    return NavigationFromJSONTyped(json, false);
}

export function NavigationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Navigation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'children': !exists(json, 'children') ? undefined : ((json['children'] as Array<any>).map(NavigationFromJSON)),
    };
}

export function NavigationToJSON(value?: Navigation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'children': value.children === undefined ? undefined : ((value.children as Array<any>).map(NavigationToJSON)),
    };
}

